import { render, staticRenderFns } from "./Decompte.vue?vue&type=template&id=5df4bb56&"
import script from "./Decompte.vue?vue&type=script&lang=js&"
export * from "./Decompte.vue?vue&type=script&lang=js&"
import style0 from "./Decompte.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports